@if (images$ | async; as images) {
  <div class="smartphoto-pictures">
    @for (item of images; track item.uuid) {
      <div
        (click)="openGallery($index)"
        class="smartphoto-pictures__image"
        [ngClass]="{ even: images.length % 2 === 0, odd: images.length % 2 !== 0 }"
        [ngStyle]="{ backgroundImage: 'url(' + item.url + ')' }"
      ></div>
    } @empty {
      <div class="smartphoto-pictures__empty">
        <div class="smartphoto-pictures__animation">
          <lottie-player src="../../../assets/animations/no-images.json" background="transparent" speed="1" loop autoplay> </lottie-player>
        </div>
        <p class="smartphoto-pictures__empty-label">{{ 'empty_images' | i18nextEager }}</p>
        @if (smartphotoService.abilities.canTakePictures$ | async) {
          <bdeo-button
            size="medium"
            type="secondary"
            skin="outline"
            text="{{ 'actions.take_pictures' | i18nextEager }}"
            icon="plus-plus"
            iconposition="left"
            htmltype="button"
            (click)="goToEvidenceCapture()"
          ></bdeo-button>
        }
      </div>
    }
  </div>
}
